import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-smoothiemakerproduct",
  "use": "icon-soc-m-smoothiemakerproduct-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-smoothiemakerproduct\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"660\" cy=\"180\" r=\"28\" /><rect x=\"192\" y=\"192\" width=\"640\" height=\"640\" rx=\"40\" /><path d=\"M288 320h448v48H288zM288 448h448v48H288zM288 576h320v48H288z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-smoothiemakerproduct.svg
// module id = 0obV
// module chunks = 477